import i18n from "i18next";
import { initReactI18next } from "react-i18next"
import zhCN from '@/locales/project/zh-CN'
import enUS from '@/locales/project/en-US'
import viVN from '@/locales/project/vi-VN'
import zhTW from '@/locales/project/zh-TW'
import antEnUS from 'antd-mobile/es/locales/en-US'
import antZhCN from 'antd-mobile/es/locales/zh-CN'
import antZhTW from 'antd-mobile/es/locales/zh-TW'
import antViVN from '@/locales/antv-moblie/vi-VN'
import storageUtil from '@/utils/localStorage'

const { getLocalStorage } = storageUtil

// i18n的语言资源map
const resources = {
  zh: {
    translation: zhCN
  },
  en: {
    translation: enUS
  },
  vi: {
    translation: viVN
  },
  'zh-TW': {
    translation: zhTW
  }
};

// antd-mobile的语言文件map
const antResources: { [key: string]: any } = {
  en: antEnUS,
  zh: antZhCN,
  vi: antViVN,
  'zh-TW': antZhTW
}

// -连接符语言转换为i18n语言
const lang2I18nMap: any = {
  'zh-CN': 'zh',
  'en-US': 'en',
  'vi-VN': 'vi',
  'zh-TW': 'zh-TW'
}

// 获取i18n的语言
export function getI18nLang() {
  const lang = getLocalStorage('language') || ''
  const systemLang = getSystemLang()
  return lang2I18nMap[lang || systemLang]
}

/**
 * 获取antd-mobile的语言文件
 * @returns 
 */
export function getAntLangFile() {
  const language: string = getI18nLang()
  return antResources[language] || antResources.en
}

// 获取后端接口的语言，_链接
export function getApiLang() {
  const lang = getLocalStorage('language') || ''
  return lang.replace('-', '_')
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getI18nLang(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

/**
 * 获取浏览器默认的语言，并转换为通用-连接符格式
 * @returns
 */
export function getSystemLang() {
  let lang = window.navigator.language || 'zh-CN'
  const map: any = {
    en: 'en-US',
    vi: 'vi-VN',
    ru: 'ru-RU',
  }
  // 如果不是-链接的，转为-链接的
  if (!lang.includes('-')) {
    if (map[lang]) {
      lang = map[lang]
    } else {
      lang = `${lang}-${lang.toUpperCase()}`
    }
  }
  return lang
}

export const langOptions = [
  { text: 'Tiếng Việt', key: 'vi-VN' },
  { text: '中文', key: 'zh-CN' },
  { text: 'English', key: 'en-US' },
  // { text: '繁體中文', key: 'zh-TW' },
]

export type LangOption = typeof langOptions[0]

export default i18n;
export const t = i18n.t
  